<template>
  <div class="plhksqDetail">
    <Header title="缓考申请详情"></Header>
    <div class="my-apply1" v-for="(item, index) in kcList" :key="index">
      <p :class="returnClass(item.shzt)">
        {{ item.shzt }}
      </p>
      <p class="apply-sub">{{ item.courseName }}[{{ item.kch }}]</p>
      <div class="info-text">
        <p>学时：{{ item.period }}</p>
        <p>学分：{{ item.credit }}</p>
        <p>考试方式：{{ item.ksfs }}</p>
      </div>
    </div>
    <div class="info-text info-text1">
      <p>审核人：{{ this.list.shr }}</p>
      <p>申请学期：{{ this.list.sqsj }}</p>
      <p>申请时间：{{ this.list.xqmc }}</p>
      <div class="reason">
        <p>申请原因：</p>
        <p class="reason-txt">{{ this.list.hkyy }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      list: [],
      kcList: []
    };
  },
  created() {
    this.list = JSON.parse(this.$route.query.data);
    this.kcList = this.list.kcdata;
  },
  methods: {
    returnClass(shzt) {
      switch (shzt) {
        case "不通过":
          return "apply-ttl btgClass";
        case "待送审":
          return "apply-ttl dssClass";
        case "审核中":
          return "apply-ttl shzClass";
        case "取消审核":
          return "apply-ttl qxshClass";
        default:
          return "apply-ttl ytgClass";
      }
    }
  }
};
</script>

<style lang="less" scoped>
.plhksqDetail {
  .my-apply1 {
    position: relative;
    padding: 10px;
    background: #f5f5f5;
    border: 1px solid #ecedfd;
    border-radius: 8px;
    margin: 0 20px 20px;
  }
  .apply-ttl {
    position: absolute;
    right: 20px;
    top: 40px;
    font-size: 20px;
    font-weight: 700;
  }
  .shzClass {
    color: #7469f8 !important;
  }
  .btgClass {
    color: #f86969 !important;
  }
  .ytgClass {
    color: #12ddd6 !important;
  }
  .dssClass {
    color: #757da3 !important;
  }
  .qxshClass {
    color: #000 !important;
  }
  .apply-sub {
    font-size: 18px;
    color: @attendance-color-1;
    font-weight: 700;
    margin-bottom: 10px;
  }
  .my-apply1 .reason {
    display: flex;
  }
  .reason-txt {
    flex: 1;
  }
  .info-text {
    font-size: 14px;
    color: @attendance-color-2;
    line-height: 20px;
  }
  .info-text1 {
    padding: 0 20px;
    font-size: 16px;
    line-height: 30px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/newPages/student/plhksq/detail.vue